import { Line } from '@/components/elements/Line'
import { NewsTagButton } from '@/components/elements/News/NewsTagButton'
import { Select } from '@/components/elements/Select'
import { AccordionFilter } from '@/components/pages/News/AccordionFilter'
import { FilterField } from '@/components/pages/News/FilterField'

type Tag = {
  name: string
  filterId: string
  isActive: boolean
}

type Props = {
  tagList: readonly Tag[]
}

export const Filter = ({ tagList }: Props) => {
  return (
    <AccordionFilter>
      <FilterField title="掲載日">
        <Select
          id="irp-press-navi"
          name="focus"
          aria-label="掲載年"
          defaultValue=""
          options={[]}
        />
      </FilterField>
        <Line color="grey" weight={1} direction="horizon" />
        <FilterField title="タグ">
          {tagList.map((tag) => (
            <NewsTagButton
              tag={tag}
              key={tag.name}
              isActive={tag.isActive}
              data-filter2={tag.filterId}
            />
          ))}
        </FilterField>
    </AccordionFilter>
  )
}
